import React, { useEffect, useState } from 'react'
import camelcaseKeys from 'camelcase-keys'
import { Dialog } from '@headlessui/react'

import reserveApi from '../../../utils/axios'

import FacilityGroupsTable from './Table'
import Button from '../../utils/Button'
import { setFlashMessage } from '../../../actions/flashActions'

export const Add = ({ facilityId, afterAdd }) => {
  const [facilityGroups, setFacilityGroups] = useState([])
  const [showAddDialog, setShowAddDialog] = useState(false)
  const [q, setQ] = useState('')

  useEffect(() => {
    reserveApi({
      method: 'get',
      url: '/admin/facility_groups',
      params: { facility_id: facilityId, q: q }
    }).then(response => {
      setFacilityGroups(camelcaseKeys(response.data, { deep: true }))
    })
  }, [facilityId, q])

  const handleAddClick = (facilityGroup) => {
    reserveApi({
      method: 'post',
      url: '/admin/facility_groups/add',
      data: { facility_group_id: facilityGroup.id, facility_id: facilityId }
    }).then(response => {
      setFlashMessage('Added to FacilityGroup')
      setShowAddDialog(false)
      afterAdd()
    })
  }

  const actions = [
    {
      label: 'Add',
      onClick: (value) => handleAddClick(value)
    }
  ]

  return (
    <div className="my-4">
      <Button color="darkGreen" size="xs" onClick={() => setShowAddDialog(true)}>Add to FacilityGroup</Button>
      <Dialog open={showAddDialog} className="fixed inset-0 z-[51] overflow-y-auto" onClose={() => setShowAddDialog(false)}>
        <div className="flex items-center justify-center min-h-screen">
          <Dialog.Overlay className="fixed inset-0 bg-black opacity-60" />
          <div className="inline-block w-full max-w-4xl my-2 mx-2 p-6 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-md">
            <input defaultValue={q} onChange={(v => setQ(v.target.value))} className="font-semibold text-lg border p-2 rounded-sm mb-2"/>
            <FacilityGroupsTable facilityGroups={facilityGroups} actions={actions} />
          </div>
        </div>
      </Dialog>
    </div>
  )
}

export default Add
